/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Modal, { ModalHeader, ModalFooter } from '../../../../components/Modal';
import AddPhoneNumber from './components/AddPhoneNumber';
import VerifyPhoneNumber from './components/VerifyPhoneNumber';
import VerifySuccessModal from './components/VerifySuccessModal';

const ModelDiv = styled.div`
  width: 720px;
  height: 441px;
  object-fit: contain;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    margin: 0 auto;
    height: 417px;
    object-fit: contain;
  }
`;


class ModalBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        phoneNumber: '',
        countryCode: '1',
        countryName: 'United States',
        verificationCode: '',
        modal: ''
    };
    this.onPhoneNumberChange = this.onPhoneNumberChange.bind(this);
    this.submit = this.submit.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.setModal = this.setModal.bind(this);
    this.onVerificationCodeChange = this.onVerificationCodeChange.bind(this);
    this.submitVerificationCode = this.submitVerificationCode.bind(this);
    this.onVerificationPress = this.onVerificationPress.bind(this);
    this.onCountryCodeChange = this.onCountryCodeChange.bind(this);
    this.resendVerificationCode = this.resendVerificationCode.bind(this);
  }

  static propTypes = {
    requests: PropTypes.object,
    onClose: PropTypes.func,
    modal: PropTypes.string
  };
    
  componentDidMount() { 
      this.setState({
        modal: this.props.modal, 
        phoneNumber: this.props.requests.subscriber.value.phoneNumber, 
        verificationCode: ''
      })

      if (this.props.requests.subscriber.value.countryName){
        this.setState({
          countryName: this.props.requests.subscriber.value.countryName,
        })
      }
  }
    
  setModal(modalType) {
      this.setState({ modal: modalType });
  }

  onCountryCodeChange(event) {
   
    const selectedIndex = event.target.options.selectedIndex;
    this.setState({ countryName: event.target.options[selectedIndex].getAttribute('c-key') });
    this.setState({ countryCode: event.target.value });
  }
  onVerificationCodeChange(event) {
    this.setState({ verificationCode: event.target.value });
  }
   
  onPhoneNumberChange(event) {
    this.setState({ phoneNumber: event.target.value });
  }
   

  onKeyPress(event) {
    if (event.key === 'Enter') {
      this.submit();
    }
  }


  onVerificationPress(event) {
    if (event.key === 'Enter') {
      this.submitVerificationCode();
    }
  }
  submitVerificationCode() {
    const payload = {
      emailAddress: this.props.requests.subscriber.value.emailAddress,
      verificationCode: this.state.verificationCode
    };
    return this.props.requests.verifyUser.handleRequest({ body: payload }).then(() => {
      if (this.props.requests.verifyUser.value.mobileNumberVerified) {
        this.setState({ modal: 'successVerifyPhone' });
        this.props.onClose('Success', 'Mobile number was successfully verified!');
      }
      this.props.requests.subscriber.handleRequest();
    })
      .catch(() => {
        this.props.requests.subscriber.handleRequest();
        this.props.onClose('failure', 'There was an error. Please try again');
      });
  }
  submit() {
    this.props.requests.addNumber
      .handleRequest({
        body: {
          emailAddress: this.props.requests.subscriber.value.emailAddress,
          countryName: this.state.countryName,
          phoneNumber: this.state.countryCode+this.state.phoneNumber
        }
      })
      .then(() => {
        this.props.requests.subscriber.handleRequest();
        // this.props.onClose(
        //   'success',
        //   'You have successfully added your phone number'
        // );
        this.setState({
          modal: 'verification',
          phoneNumber: this.state.countryCode+this.state.phoneNumber
        })
      })
      .catch(() => {
        this.props.requests.subscriber.handleRequest();
        this.props.onClose('failure', 'There was an error. Please try again');
      });
  }
  resendVerificationCode() {
    const payload = {
      emailAddress: this.props.requests.subscriber.value.emailAddress,
      countryName: this.state.countryName,
      phoneNumber: this.props.requests.subscriber.value.phoneNumber
    };
    this.props.requests.addNumber.handleRequest({ body: payload }).then(() => {
      this.props.requests.subscriber.handleRequest();
    });
  }
  render() {
    return (
      <Modal isOpen={true} onClose = {this.props.onClose}>
            <ModelDiv>
                
          {this.state.modal === 'addPhone' && (
            <AddPhoneNumber phoneNumber={this.state.phoneNumber} onKeyPress={this.onKeyPress} onPhoneNumberChange={this.onPhoneNumberChange} requests={this.props.requests}
              submit={this.submit} setModal={this.setModal} countryCode={ this.state.countryCode } onCountryCodeChange = {this.onCountryCodeChange} />
          )}
          {this.state.modal === 'verification' && (
            <VerifyPhoneNumber requests={this.props.requests} verificationCode={this.state.verificationCode} phoneNumber={this.state.phoneNumber} resendVerificationCode={this.resendVerificationCode}
              onVerificationCodeChange = {this.onVerificationCodeChange} submit={this.submitVerificationCode} onKeyPress = {this.onVerificationPress} onClose = {this.props.onClose}
            >
            </VerifyPhoneNumber>
          )}
          {this.state.modal === 'successVerifyPhone' && (
            <VerifySuccessModal requests={this.props.requests} phoneNumber={this.state.phoneNumber} onClose = {this.props.onClose}
            >
            </VerifySuccessModal>
          )}
        </ModelDiv>
    </Modal>
    );
  }
}

export default ModalBody;
